import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import {
  Observable,
  Subscription,
  catchError,
  defer,
  finalize,
  map,
  tap,
  throwError,
} from 'rxjs';
import { LoadingService } from '../services/loading.service';
import { ToastController } from '@ionic/angular';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AppLoadingInterceptor implements HttpInterceptor {
  private countRequest = 0;

  private excludedUrls: string[] = [
    '/data-values/',
    '/executors/',
    '/advisories/',
    '/mark-ready'
  ];

  constructor(
    private _loadingService: LoadingService,
    private toastController: ToastController,
    private authService: AuthService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let token = localStorage.getItem('token');

    const hasAuthorization = request.headers.has('Authorization');
    const isS3Request = request.url.includes('s3.amazonaws.com');
    const executorToken = this.authService.externalToken?.trim();
    const isExecutorEndpoint = request.url.includes('/operations/executor/');

    if (!hasAuthorization && !isS3Request) {
      let authValue: string | null = null;

      if (executorToken && isExecutorEndpoint) {
        authValue = executorToken.toLowerCase().startsWith('token ')
          ? executorToken
          : `token ${executorToken}`;
      } else if (token) {
        authValue = `${token}`;
      }

      if (authValue) {
        request = request.clone({
          setHeaders: {
            Authorization: authValue,
          },
        });
      }
    }

    return next.handle(request).pipe(
      finalize(() => {}),
      catchError((errorResponse: HttpErrorResponse) => {
        const shouldExclude = this.excludedUrls.some((url) =>
          request.url.includes(url)
        );
        if (!shouldExclude) {
          this.presentToast(errorResponse.message);
        }
        if (errorResponse.status === 401) {
          this.authService.logout();
        }

        return throwError(() => errorResponse);
      })
    );
  }

  private async presentToast(message: string) {
    const toast = await this.toastController.create({
      message: `Ocurrió un error en el sistema.\n${message}`,
      duration: 2500,
      position: 'bottom',
      color: 'danger',
      buttons: [
        {
          text: 'Cerrar',
          role: 'cancel',
        },
      ],
    });

    await toast.present();
  }
}
